import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import axios from 'axios'
import Visual from "./visual";

const ResultsModal = (props) => {



  const [tab, setTab] = useState(0);
  const [allNotes, setAllNotes] = useState([
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros elementum tristique. Duis cursus, mi quis viverra ornare, eros dolor interdum nulla, ut commodo diam libero vitae erat. Aenean faucibus nibh et justo cursus id rutrum lorem imperdiet. Nunc ut sem vitae risus tristique posuere.",
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros elementum tristique. Duis cursus, mi quis viverra ornare, eros dolor interdum nulla, ut commodo diam libero vitae erat. Aenean faucibus nibh et justo cursus id rutrum lorem imperdiet. Nunc ut sem vitae risus tristique posuere.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros elementum tristique. Duis cursus, mi quis viverra ornare, eros dolor interdum nulla, ut commodo diam libero vitae erat. Aenean faucibus nibh et justo cursus id rutrum lorem imperdiet. Nunc ut sem vitae risus tristique posuere.",
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros elementum tristique. Duis cursus, mi quis viverra ornare, eros dolor interdum nulla, ut commodo diam libero vitae erat. Aenean faucibus nibh et justo cursus id rutrum lorem imperdiet. Nunc ut sem vitae risus tristique posuere",
  ]);

  const addNewNote = () => {
    setAllNotes(n => [...n, "Add notes here..."]);
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const handleAddCollaborator = () => {
    console.log('')
  }

  const startAnalysis = () => {
    axios.post('http://34.134.128.3/vm/create', {
            "environment": "PROD",
            "projectId": "data-science-siatik",
            "vmDetails": [
                {
                    "action": "CREATE",
                    "instanceName": "pr-integ-test-2",
                    "region": "us-central1",
                    "zone": "us-central1-a",
                    
                    "machineType": "e2-standard-8",
                    "preemptible": false,
                    "startupScript": "gs://siatik_skygenic_service_scripts/pipeline-runner/pipeline-runner.sh",
                    "labels": {
                        "owner": "pipeline-unit-test-instance-owner"
                    }
                }
            ]
        },  {
            'Content-Type': 'application/json',
        },).then((x) => {
          console.log(x)
        })
  }

  return (
    <>
      {/* <div className="div-block-12"> */}
      <div className="div-block-13">
        <div className="text-block-2">Run Name</div>
        <div className="text-block">Status</div>
        <div className="text-block">Completion Date</div>
        <div className="div-block-50">
          <div className="div-block-51">Edit</div>
          <div className="div-block-51 active">Run</div>
          <div className="div-block-25" onClick={() => props.setOpenResultsModal(false)}>
              <img
                src="https://uploads-ssl.webflow.com/60faa77e21b22054e04713b8/60fc3a2f21621b84f7932381_icons8-back-96.png"
                loading="lazy"
                width={16}
                alt=""
              />
              <div className="text-block-3">Close</div>
            </div>
        </div>
      </div>
      <div className="div-block-27">
        <div className="div-block-39" onClick={() => setTab(0)}
        style={ tab === 0 ? {
          backgroundColor:  "#4986ff",
          color: "#fff"
        }: {}}
        >
          Report
        </div>
        <div className="div-block-39" onClick={() => setTab(1)}
        style={ tab === 1 ? {
          backgroundColor:  "#4986ff",
          color: "#fff"
        } : {}}
        >
          Parameters
        </div>
        <div className="div-block-39" onClick={() => setTab(2)}
        style={ tab === 2 ? {
          backgroundColor:  "#4986ff",
          color: "#fff"
        }: {}}
        >
          Interactive Visualization
        </div>
      </div>
      <div
        style={{
          display: tab === 0 ? "" : "none",
        }}
      >
        <div
          className="div-block-44"
          style={{
            height: "46%",
          }}
        >
          <div className="text-block-copy">Notes</div>

          {allNotes.map((note, i) => {
            return (
              <form onSubmit={handleSubmit(handleAddCollaborator)}>
              <div className="div-block-45" contentEditable>
                <div className="text-block-19">
                  {note}
                </div>
                {/* <input
                      className="text-block-19"
                      name="email"
                      id="email"
                      type="text"
                      {...register("email", { required: true, maxLength: 200 })}
                    /> */}
                <div className="div-block-47">User name - 01/01/2021</div>
              </div>
              </form>
            );
          })}

          <div className="add-notes-button" onClick={() => addNewNote()}>
            Click To Add Notes
          </div>
        </div>
        <div className="div-block-26">
          <div className="div-block-40">
            <div className="div-block-41">Outputs</div>
          </div>
          <div className="div-block-42">
            <div>Report output...</div>
            <div className="div-block-48">Download</div>
          </div>
        </div>
      </div>
      <div
        style={{
          display: tab === 1 ? "" : "none",
        }}
      >
        <div className="div-block-26 params">
          <div className="div-block-46">
            <div className="text-block-20" onClick={startAnalysis}>Analysis</div>
            <div className="text-block-20">Star</div>
            <div className="text-block-20">Version 2.1</div>
          </div>
          <div className="div-block-40">
            <div className="div-block-41">Inputs</div>
            <div className="div-block-41">Settings</div>
            <div className="div-block-41">Outputs</div>
          </div>
          <div className="div-block-42" />
        </div>

        <div className="div-block-26 params">
          <div className="div-block-46">
            <div className="text-block-20">Step 2</div>
            <div className="text-block-20">App 2</div>
            <div className="text-block-20">Version 3.4.1</div>
          </div>
          <div className="div-block-40">
            <div className="div-block-41">Inputs</div>
            <div className="div-block-41">Settings</div>
            <div className="div-block-41">Outputs</div>
          </div>
          <div className="div-block-42" />
        </div>


        <div className="div-block-49">Master File Download </div>
        {/* </div> */}
      </div>
      <div
        style={{
          display: tab === 2 ? "" : "none",
        }}
      >
        <Visual />
        </div>
    </>
  );
};

export default ResultsModal;
